import React from 'react';
import { SectionPanel } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';

import { ComplexValue, LoadOptions } from 'app/types-shared';

import { DashboardAdminTranslation } from '../../constants';
import { DashboardSectionType } from '../metroline/types';
import { userGroupCodetableId } from '../constants';
import { endpoints } from '../endpoints';
import { DashboardItem, DashboardItemValidation } from '../types-store';
import { ReportCode } from 'app/area/shared/report/report-code';

const subsetId = 'subset';
const applicationId = 'application';
const personId = 'person';

interface DashboardVisibilityProps extends WithMetroLineWrappedComponentProps<DashboardSectionType> {
  dashboardItem: DashboardItem;
  updateItem: (item: Partial<DashboardItem>) => void;
  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  validation: DashboardItemValidation;
  translation: DashboardAdminTranslation;

  section: string;
  locale: string;
}

export const DashboardVisibility: React.FC<DashboardVisibilityProps> = ({
  dashboardItem, updateItem,
  options, loadOptions,
  validation, translation, locale,
  section, getRef, shouldRenderSection
}) => {

  const onSubsetChange = (values: ComplexValue<number>[]) => {
    updateItem({ subset: values });
  };

  const onApplicationChange = (values: ComplexValue<number>[]) => {
    updateItem({ application: values });
  };

  const onPersonChange = (values: ComplexValue<number>[]) => {
    updateItem({ person: values });
  };

  return <MetroLineSection<DashboardSectionType>
    section={section}
    sectionType={DashboardSectionType.Visibility}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(DashboardSectionType.Visibility)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={DashboardSectionType.Visibility}
        validation={undefined}
        info={{ text: translation.visibility }}
        label={{ visible: true, text: translation.visibility }} />
      <MainGridContainer>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <ReportCode
              id={subsetId}
              label={translation?.visible_for_user_groups}
              isHierarchy={true}
              values={dashboardItem?.subset}
              onChange={onSubsetChange}
              optionsEndpoint={endpoints.userGroupOptions}
              options={options && options[subsetId]}
              loadOptions={loadOptions}
              validation={validation?.subset}
              searchLabel={translation?.search}
              manageOptionsId={userGroupCodetableId}
              manageOptionsLabel={translation.manage_options}
              locale={locale} />
          </div>
          <div className="col-lg-6 col-sm-12">
            <ReportCode
              id={applicationId}
              label={translation?.visible_for_case_types}
              isHierarchy={true}
              values={dashboardItem?.application}
              onChange={onApplicationChange}
              optionsEndpoint={endpoints.caseTypeOptions}
              options={options && options[applicationId]}
              loadOptions={loadOptions}
              validation={validation?.application}
              searchLabel={translation?.search}
              locale={locale} />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-sm-12">
            <ReportCode
              id={personId}
              label={translation?.visible_for_users_and_roles}
              isHierarchy={false}
              values={dashboardItem?.person}
              onChange={onPersonChange}
              optionsEndpoint={endpoints.personOptions}
              options={options && options[personId]}
              loadOptions={loadOptions}
              validation={validation?.person}
              searchLabel={translation?.search}
              locale={locale} />
          </div>
        </div>
      </MainGridContainer>
    </div>
  </MetroLineSection>;
};
